import React from 'react'
import { FieldRenderProps } from 'react-final-form'
import Checkbox from '../Checkbox'
import FormGroup, { FormGroupProps } from '../FormGroup'
import { parseMessage } from '../Forms/utils'

type CheckboxFieldProps = FieldRenderProps<boolean | string, HTMLElement>

const CheckboxField = ({
  input: { value, ...input },
  meta: { touched, error },
  ...props
}: CheckboxFieldProps) => {
  const parsedError = parseMessage(error)

  return (
    <FormGroup
      {...(input as unknown as FormGroupProps & {
        ref: React.LegacyRef<FormGroup>
      })}
      touched={touched}
      error={parsedError}
    >
      <Checkbox {...input} {...props} checked={!!value} />
    </FormGroup>
  )
}

export default CheckboxField
